module.exports = require('./dist/iso3166-1')
